// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"34":"95567b7d","44":"852244df","289":"c40d70e7"}[chunkId] + ".css";
};